'use strict';

/**
 * @param $form JQuery
 */
function Captcha($form) {

	/** @type JQuery */
	this.$form = $form;

	/** @type string|null */
	this._captchaCode = null;

	/**
	 * @returns jQuery Captcha image object
	 */
	this.reloadCaptcha = function() {

		if (this._captchaCode === null) {
			this._loadCaptchaCode();
		}

		// Obfuscated on purpose due to Google bot attempts to follow links from JS
		// Joins into "/generate-captcha/gcb_captcha?v=1504708077333"
		var url = [['', 'generate-captcha', 'gcb_captcha'].join('/'), ['v', (new Date()).getTime()].join('=')].join('?');

		return $form.find('.captcha-image').attr('src', url);

	};

	/**
	 * @returns function()
	 * @private
	 */
	this._getCaptchaReloadingFunction = function() {
		var fnName = 'reload_captcha_' + this._captchaCode;
		return new Function(fnName + '();');
	};

	/**
	 * @private
	 */
	this._loadCaptchaCode = function() {
		/** @type JQuery */
		var captchaImageElement = $form.find('.captcha-image');
		if (!captchaImageElement.size()) {
			console.error('Fetched no captcha image element');
			return;
		}
		this._captchaCode = captchaImageElement
			.attr('id')
			.replace(/^.+_/g, '');
	};

}

var sendToEmail = function () {
	var sendIt = function () {

		var $form = $('#send_email');
		var blockSubmission = false;
		var captcha = new Captcha($form);

		$form.submit(function (e) {
			e.preventDefault();
			var catcher = $('.send-email-catcher');

			if (blockSubmission) {
				console.error('Submission blocked')
				return;
			}
			blockSubmission = true;

			var formData = {};
			$(this).find('input, textarea').each(function() {
				formData[$(this).attr('name')] = $(this).val();
			});


			$.ajax({
				url: '/ajax/send-email',
				type: 'POST',
				data: formData,
				beforeSend: function() {
					hideMessages();
					catcher.find('.send-email-msg.sending').removeClass('hidden');
				},
				success: function() {
					hideMessages();
					catcher.find('.send-email-msg.confirm').removeClass('hidden');
					setTimeout(function () {
						$.magnificPopup.close();
					}, 1000);
				},
				error: function(jqXHR) {
					hideMessages();
					catcher.find('.send-email-msg.error').each(function() {
						if (jqXHR.status === 400 && jqXHR.responseJSON) {
							if (typeof jqXHR.responseJSON['errors'] !== 'undefined' && (jqXHR.responseJSON['errors'] instanceof Array)) {
								if (!$(this).data('html')) $(this).data('html', $(this).html());
								$(this).html(jqXHR.responseJSON['errors'].join('<br>'));
							}
							if (typeof jqXHR.responseJSON['reload_captcha'] !== 'undefined' && jqXHR.responseJSON['reload_captcha']) {
								captcha.reloadCaptcha();
								$form.find('#captcha').val('');
							}
						} else {
							if ($(this).data('html')) $(this).html($(this).data('html'));
						}
						$(this).removeClass('hidden')
					});
				},
			}).always(function() {
				console.log('unblocked');
				blockSubmission = false;
			});
		});
	};

	var hideMessages = function () {
		var catcher = $('.send-email-catcher');
		catcher.find('.send-email-msg').each(function(){
			$(this).addClass('hidden');
		});
	};

	var init = function () {
		sendIt();
	};

	return {
		init: init
	};
}();

UL.register(sendToEmail);
